import React from 'react';
import { StyleSheet, View } from './base_components';

import PropList from './prop_list';
import StandardBoxList from './standard_box_list';
import TextButton from './buttons/text_button';

import util from '../tools/util';

const styles = StyleSheet.create({
  actionButton: {
    marginRight: '1rem',
  },
  bottomLine: {
    alignSelf: 'stretch',
    height: '5rem',
    backgroundColor: 'var(--box-header-bg-color)',
    borderTopWidth: 1,
    borderColor: 'var(--box-inner-line-color)',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

export default function BoxPropList(props) {
  const { editable, updates, alwaysEdit } = props;
  const [is_editing, setEditing] = React.useState(alwaysEdit ?? false);

  function _onEditPress() {
    setEditing(true);
  }
  function _onCancelPress() {
    setEditing(alwaysEdit ?? false);
    props.onChange({});
  }
  function _onSavePress() {
    props.onSave((err?: any) => {
      if (!err) {
        _onCancelPress();
      }
    });
  }

  const buttons =
    !is_editing && editable ? (
      <>
        <TextButton
          style={styles.actionButton}
          text='Edit'
          onPress={_onEditPress}
        />
      </>
    ) : null;
  function _onChange(item, value) {
    let found_item;
    props.columns.forEach((column) =>
      column.forEach((cell) => {
        if (cell.key === item.key) {
          found_item = cell;
        }
      })
    );
    const new_updates = Object.assign({}, updates);
    if (found_item) {
      if (item.initialValue !== undefined && item.initialValue === value) {
        delete new_updates[item.key];
      } else if (
        item.initialValue === undefined &&
        found_item.value === value
      ) {
        delete new_updates[item.key];
      } else {
        new_updates[item.key] = value;
      }
    }
    props.onChange(new_updates);
  }
  let modified = false;
  let is_valid = true;
  const edited_columns = util.deepClone(props.columns);
  if (is_editing) {
    edited_columns.forEach((column) => {
      column.forEach((cell) => {
        if (cell.initialValue) {
          cell.value = cell.initialValue;
        }
        if (
          cell.key &&
          updates[cell.key] !== undefined &&
          updates[cell.key] !== cell.value
        ) {
          modified = true;
          cell.value = updates[cell.key];
        }
        if (cell.key && cell.required && !cell.value) {
          is_valid = false;
        }
      });
    });
  }

  return (
    <StandardBoxList title={props.title} buttons={buttons}>
      <PropList
        columns={edited_columns}
        editing={is_editing}
        onChange={_onChange}
      />
      {is_editing ? (
        <View style={styles.bottomLine}>
          {props.editButtons}
          {alwaysEdit ? null : (
            <TextButton
              style={styles.actionButton}
              text='Cancel'
              onPress={_onCancelPress}
            />
          )}
          <TextButton
            style={styles.actionButton}
            text='Save'
            disabled={!modified || !is_valid}
            onPress={_onSavePress}
          />
        </View>
      ) : null}
    </StandardBoxList>
  );
}
